import React, { useCallback, useEffect, useState } from "react";
import Shimmer from "../Common/Shimmer";
import { Callout } from "../ui";
import apiClient from "../../utils/apiClient";
import EmailServerSettings from "./EmailServerSettings";
import SmsGatewaySettings from "./SmsGatewaySettings";

/**
 * Settings → Email & SMS.
 *
 * The institute's own mail server and SMS gateway. Until either is set up the
 * platform's sender is used, exactly as before; nothing here changes an
 * institute that never opens this tab. Server rules: vc_be
 * controllers/communicationSettingsController.js.
 */
export default function CommunicationSettings({ showToast, brandName }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setError("");
    try {
      const res = await apiClient.get("/institute/communications");
      setData(res.data?.data || null);
    } catch (err) {
      setError(err?.response?.data?.message || "Could not load email and SMS settings.");
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (error) {
    return (
      <div className="tw-mt-4">
        <Callout tone="danger" role="alert">{error}</Callout>
      </div>
    );
  }
  if (!data) {
    return (
      <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-4">
        <Shimmer height={220} />
        <Shimmer height={220} />
      </div>
    );
  }

  return (
    <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-4">
      <EmailServerSettings
        saved={data.email}
        platformSender={data.platform?.senderEmail || "noreply@lmscampus.com"}
        brandName={brandName}
        showToast={showToast}
        onSaved={(email) => setData((d) => ({ ...d, email }))}
      />
      <SmsGatewaySettings
        saved={data.sms}
        brandName={brandName}
        showToast={showToast}
        onSaved={(sms) => setData((d) => ({ ...d, sms: { ...sms, usageToday: sms.usageToday ?? d.sms.usageToday } }))}
      />
    </div>
  );
}
